import {
	Container, Divider,
	Grid, Typography
} from '@material-ui/core';
import {
	BackspaceOutlined as BackspaceOutlinedIcon,
	Print as PrintIcon
} from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Select from '../../components/Form/Select';
import TextField from '../../components/Form/TextField';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { MvmNoJustificationWindowReportParams } from '../../interfaces/Report';
import ReportApi from '../../services/ReportApi';
import { useStyles } from '../../utils/DefaultStyles';
import permissions from '../../utils/Permissions';

const MvmNoWindowJustificationReport: React.FC = () => {
	const classes = useStyles();
	const { user, hasPermission } = useAuth();
	const { t: _t } = useTranslation('General');
	const { t } = useTranslation('Reports');
	const history = useHistory();
	const { enqueueSnackbar } = useSnackbar();

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		if (!hasPermission(permissions.REPORTS.ShippingRequest))
			history.replace('/NoPermission');
	}, [history, user]);

	//Campos do Form
	interface IFormPanel {
		startDate: any;
		endDate: any;
        renderType: any;
	}

	//Metodos do form:
	const { handleSubmit, reset, control, getValues } =
		useForm<IFormPanel>({
			defaultValues: {
				startDate: '',
				endDate: '',
				renderType: {code: '2', label: 'Excel'}
			},
		});

	const onSubmit = async (data: any) => {
		data.supplierNames = data.suppliers.map(
			(x: any) => x.code + ' - ' + x.name
		);
		data.supplierIds = data.suppliers.map((x: any) => x.code);
		data.companyId = user.company.companyID;
		data.userName = user.name;

		ReportApi.printBusinessSecurity(data);
	};

	const cleanFilters = () => {
		reset();
	};

	async function generateReport(data: any) {
		var params: MvmNoJustificationWindowReportParams = {
			companyId: +user.company.companyID,
			startDate: data?.startDate,
			endDate: data?.endDate,
			renderType: data.renderType.code,
			userName: user.name
		};

		ReportApi.printMvmNoJustificationWindow(params)
			.catch((err) => {
				enqueueSnackbar(err.data, {
					variant: 'error',
				});
			});
	}

	return (
		<Container maxWidth={false} component='main'>
			<PageTitle
				title={t('pageTitle') + t('mvmNoWindowJustification.pageTitle')}
			/>

			<div className={classes.rootContent}>
				<div className={classes.paper}>
					<form
						translate={undefined}
						onSubmit={handleSubmit(onSubmit)}
					>
						<Grid container spacing={1}>
							<Grid
								item
								xs={6}
								style={{
									padding: '0px',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<Typography className={classes.root}>
									{t('titleParameters')}
								</Typography>
							</Grid>

							<Grid
								item
								xs={6}
								style={{ padding: '0px', textAlign: 'right' }}
							>
								<ButtonUI
									onClick={() => cleanFilters()}
									startIcon={<BackspaceOutlinedIcon />}
								>
									{_t('clean')}
								</ButtonUI>
								<ButtonUI
									color='primary'
									onClick={() => generateReport(getValues())}
									startIcon={<PrintIcon />}
								>
									{t('print')}
								</ButtonUI>
							</Grid>
						</Grid>

						<Divider style={{ marginTop: '10px' }} />

						<Grid container spacing={1}>
							<Grid item xs={2}>
								<TextField
									label={t(
										'mvmNoWindowJustification.startDate'
									)}
									name='startDate'
									control={control}
									type='date'
									InputLabelProps={{ shrink: true }}
									fullWidth
								/>
							</Grid>

							<Grid item xs={2}>
								<TextField
									label={t('mvmNoWindowJustification.endDate')}
									name='endDate'
									control={control}
									type='date'
									InputLabelProps={{ shrink: true }}
									fullWidth
								/>
							</Grid>

                            <Grid item xs={1}>
                                <Select
                                    label={_t("reportExportType")} 
                                    name="renderType"
                                    control={control} 
                                    options={[{code: '2', label: 'Excel'}, {code: '1', label: 'PDF'}]}
                                    style={{width: '100%'}}/>
                            </Grid>
						</Grid>
					</form>
				</div>
			</div>
		</Container>
	);
};
export default MvmNoWindowJustificationReport;
